// importando estilização do componente
import style from './Styles.module.css'
import { Styled } from './Styled'

export const Blog: React.FC = () => {

    return (
        <Styled.Content>
            <div className={style.FullArea}>

            </div>
            <div className={style.MenuArea}>

            </div>           
        </Styled.Content>
    )
}
// aqui estamos exportando nosso componente
